import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from "./App";

// ✅ PERFORMANCE: React Query client with optimal settings for client-side caching
// 🚫 ANALYTICS EXCLUDED: This caching system is only used by Dashboard and Email Campaigns
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,      // 5 min - data considered fresh
      cacheTime: 30 * 60 * 1000,     // 30 min - cache retained in memory
      refetchOnWindowFocus: false,   // Don't refetch on tab switch
      refetchOnReconnect: true,      // Refetch on network reconnect
      retry: 1,                      // Only retry once on failure
      retryDelay: 1000,              // 1s between retries
    },
  },
});

console.log('✅ React Query client initialized with 5min stale time, 30min cache retention');
console.log('🚫 Cache only active for Dashboard and Email Campaigns - Analytics untouched');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
    {/* Show React Query DevTools in development */}
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

// Build tracking - Persistent console message with bundle hash  
const BUILD_ID = '__BUILD_ID__'; // Will be injected during deployment
const BUNDLE_HASH = '__BUNDLE_HASH__'; // Will be injected during deployment

console.log('%c🔥 AFC BUILD DEPLOYED', 'background: #1890ff; color: white; padding: 8px 16px; font-size: 14px; font-weight: bold; border-radius: 4px;');
console.log('%cBuild ID: ' + BUILD_ID, 'color: #1890ff; font-size: 13px; font-weight: bold;');
console.log('%cBundle Hash: main.' + BUNDLE_HASH + '.js', 'color: #52c41a; font-size: 13px; font-weight: bold;');
console.log('%c━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━', 'color: #1890ff;');
console.log('%cTo verify deployment:', 'color: #faad14; font-size: 12px;');
console.log('%c  1. Check Network tab for main.' + BUNDLE_HASH + '.js', 'color: #999; font-size: 11px;');
console.log('%c  2. Type: window.AFC_BUILD_INFO', 'color: #999; font-size: 11px;');

// Store build info globally for easy verification
window.AFC_BUILD_ID = BUILD_ID;
window.AFC_BUNDLE_HASH = BUNDLE_HASH;
window.AFC_BUILD_INFO = { buildId: BUILD_ID, bundleHash: 'main.' + BUNDLE_HASH + '.js', deployed: new Date().toISOString() };
console.log('🔥 AFC Build ID: 20251027035151')
console.log('🔥 AFC Build ID: 20251027035500')
console.log('🔥 AFC Build ID: 20251027043042')
console.log('🔥 AFC Build ID: 20251027043843')
console.log('🔥 AFC Build ID: 20251027050929')
console.log('🔥 AFC Build ID: 20251027053002')
console.log('🔥 AFC Build ID: 20251029034147')
console.log('🔥 AFC Build ID: 20251029141751')
console.log('🔥 AFC Build ID: 20251029225455')
console.log('🔥 AFC Build ID: 20251029232835')
console.log('🔥 AFC Build ID: 20251029235822')
console.log('🔥 AFC Build ID: 20251030001221')
console.log('🔥 AFC Build ID: 20251030002812')
console.log('🔥 AFC Build ID: 20251030005902')
console.log('🔥 AFC Build ID: 20251030014002')
console.log('🔥 AFC Build ID: 20251030023327')
console.log('🔥 AFC Build ID: 20251030035453')
console.log('🔥 AFC Build ID: 20251030045415')
console.log('🔥 AFC Build ID: 20251030050647')
console.log('🔥 AFC Build ID: 20251030063229')
console.log('🔥 AFC Build ID: 20251030163401')
console.log('🔥 AFC Build ID: 20251030172415')
console.log('🔥 AFC Build ID: 20251030174053')
console.log('🔥 AFC Build ID: 20251030182851')
console.log('🔥 AFC Build ID: 20251030183700')
console.log('🔥 AFC Build ID: 20251030184726')
console.log('🔥 AFC Build ID: 20251031004839')
console.log('🔥 AFC Build ID: 20251031192933')
console.log('🔥 AFC Build ID: 20251031194949')
console.log('🔥 AFC Build ID: 20251031232114')
console.log('🔥 AFC Build ID: 20251031235301')
console.log('🔥 AFC Build ID: 20251101002710')
console.log('🔥 AFC Build ID: 20251101004646')
console.log('🔥 AFC Build ID: 20251101005648')
console.log('🔥 AFC Build ID: 20251101020116')
console.log('🔥 AFC Build ID: 20251101024137')
console.log('🔥 AFC Build ID: 20251101031624')
console.log('🔥 AFC Build ID: 20251101033059')
console.log('🔥 AFC Build ID: 20251101034220')
console.log('🔥 AFC Build ID: 20251101140646')
console.log('🔥 AFC Build ID: 20251101204522')
console.log('🔥 AFC Build ID: 20251101205629')
console.log('🔥 AFC Build ID: 20251101212757')
console.log('🔥 AFC Build ID: 20251101215936')
console.log('🔥 AFC Build ID: 20251102001111')
console.log('🔥 AFC Build ID: 20251102005729')
console.log('🔥 AFC Build ID: 20251102010459')
console.log('🔥 AFC Build ID: 20251102020428')
console.log('🔥 AFC Build ID: 20251102030121')
console.log('🔥 AFC Build ID: 20251102032305')
console.log('🔥 AFC Build ID: 20251102034422')
console.log('🔥 AFC Build ID: 20251102043253')
console.log('🔥 AFC Build ID: 20251102045549')
console.log('🔥 AFC Build ID: 20251102050846')
console.log('🔥 AFC Build ID: 20251102053327')
console.log('🔥 AFC Build ID: 20251102054228')
console.log('🔥 AFC Build ID: 20251102123402')
console.log('🔥 AFC Build ID: 20251102125824')
console.log('🔥 AFC Build ID: 20251102130237')
console.log('🔥 AFC Build ID: 20251102132841')
console.log('🔥 AFC Build ID: 20251102134725')
console.log('🔥 AFC Build ID: 20251102141629')
console.log('🔥 AFC Build ID: 20251102143210')
console.log('🔥 AFC Build ID: 20251103051322')
console.log('🔥 AFC Build ID: 20251103052715')
console.log('🔥 AFC Build ID: 20251104042206')
console.log('🔥 AFC Build ID: 20251104044300')
console.log('🔥 AFC Build ID: 20251104055755')
console.log('🔥 AFC Build ID: 20251104133555')
console.log('🔥 AFC Build ID: 20251104141351')
console.log('🔥 AFC Build ID: 20251104141900')
console.log('🔥 AFC Build ID: 20251104152751')
console.log('🔥 AFC Build ID: 20251104234517')
console.log('🔥 AFC Build ID: 20251105020128')
console.log('🔥 AFC Build ID: 20251105043139')
console.log('🔥 AFC Build ID: 20251106025231')
console.log('🔥 AFC Build ID: 20251106030433')
console.log('🔥 AFC Build ID: 20251109204101')
console.log('🔥 AFC Build ID: 20251112000000 - Apify 3hr timeout + stable auth')
console.log('🔥 AFC Build ID: 20251113000500 - Mobile cache fix (instant campaigns)')
